<template>
  <div>
    <!-- <progress class="progress is-link" value="50" max="100">50%</progress> -->
    <div class="box">
      <h1 class="page-header">
        Property Information
      </h1>
      <div class="columns is-multiline">
        <div class="column is-half">

          <div class="field">
            <label class="label">Property Owner Full Name</label>
            <div class="control">
              <input class="input" type="text" placeholder="Enter Property Owner Full Name" v-model="Request.PropertyOwnerName">
            </div>
          </div>

          <div class="field">
            <label class="label">Property Address</label>
            <div class="control">
              <input class="input" type="text" placeholder="Enter Property Address" v-model="Request.PropertyAddress">
            </div>
          </div>

          <div class="field">
            <label class="label">Loan Number</label>
            <div class="control">
              <input class="input" type="text" placeholder="Enter Loan Number" v-model="Request.LoanNumber">
            </div>
          </div>

          <div class="field">
            <label class="label">Certificate Holder</label>
            <div class="control">
              <textarea class="textarea" type="text" style="resize: none;" placeholder="Enter Lender Certificiate Holder Information" v-model="Request.CertificateHolder"></textarea>
            </div>
          </div>
        </div>
        <div class="column is-half">
          <div class="field">
            <label class="label">Association Name</label>
            <div class="control">
              <input disabled class="input" type="text" v-model="Request.Association.Name">
            </div>
          </div>

          <div style="padding-top: 30px;" class="has-text-centered">
            <i class="fa fa-check fa-4x"></i>
            <p>We have located your evidence of insurance. Please complete the fields and click next to continue.</p>
            <br>
          </div>

          <div v-if="submitted" style="padding-top: 50px; " class="has-text-centered opaque ">
            <i class="fa fa-refresh fa-spin fa-4x "></i>
            <p>Updating Request...</p>
          </div>
        </div>
        <div class="column is-half">
          <div style="margin-top: 20px;" class="field is-grouped">
            <div class="control">
              <button class="button is-text" @click="cancel">Cancel</button>
            </div>
            <div class="control">
              <button @click="previous()" class="button is-outlined">Previous</button>
            </div>
            <div class="control">
              <button @click="next()" class="button is-link">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LenderInformation',
    props: ['Request'],
    data: function () {
      return {
        submitted: false,
        found: false
      }
    },
    methods: {
      next() {
        this.submitted = true
        this.found = false
        this.$emit('next')
      },
      previous() {
        this.$emit('previous')
      },
      cancel() {
        this.$emit('cancel')
      }
    }
  }

</script>


// WEBPACK FOOTER //
// src/components/request/PropertyInformation.vue?11349f96